import { createFileRoute, useParams } from "@tanstack/react-router";
import { z } from "zod";
import { ItemDetailPage } from "@/components/inventory/ItemDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/items_/$id")({
  // Optional in the schema (unlike the CRM/User detail routes) — Item's
  // detail page is linked to from several list/table components that don't
  // (and shouldn't have to) specify a tab, unlike Account/Contact/User's
  // detail routes which are only ever navigated to from their own internal
  // tab switching.
  validateSearch: z.object({ tab: z.string().optional().catch(undefined) }),
  component: AdminItemDetail,
});

function AdminItemDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/items_/$id" });
  const { tab } = Route.useSearch();
  return <ItemDetailPage itemId={id} activeTab={tab} />;
}
